"use client";

import React from 'react';
import { motion } from 'framer-motion';
import { LastUpdatedRates } from './ui';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      // Redirect is handled automatically by the auth context/protected route
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-100 transition-colors duration-300">
      <div className="container mx-auto px-1 py-6 max-w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <header className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <img src="/calculator-icon.svg" alt="Calculator Icon" className="w-10 h-10" />
              <h1 className="gradient-heading text-4xl md:text-5xl">SmartSaver</h1>
            </div>
            
            {/* Desktop layout - LastUpdatedRates on the right */}
            <div className="hidden sm:flex sm:items-center sm:justify-between">
              <p className="text-muted-foreground">Compare rates and find the best banking options for your needs</p>
              <LastUpdatedRates />
            </div>
            
            {/* Mobile layout - LastUpdatedRates inline after text */}
            <div className="sm:hidden">
              <p className="text-muted-foreground inline">
                Compare rates and find the best banking options for your needs{' '}
                <span className="inline-flex items-center ml-1">
                  <LastUpdatedRates />
                </span>
              </p>
            </div>
          </header>
          
          <main>
            {children}
          </main>

        </motion.div>
      </div>
      
      {/* Background decorative elements */}
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-[-1]">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[20%] right-[10%] w-80 h-80 bg-secondary/5 rounded-full blur-3xl"></div>
        <div className="absolute top-[40%] right-[25%] w-72 h-72 bg-indigo/5 rounded-full blur-3xl"></div>
      </div>

      {/* User info and sign out button */}
      {user && (
        <div className="fixed bottom-0 left-0 w-full p-4">
          <div className="user-menu flex items-center justify-end gap-4">
            <div className="user-info flex items-center gap-2">
              {user.user_metadata?.avatar_url ? (
                <img 
                  src={user.user_metadata.avatar_url} 
                  alt="Profile" 
                  className="w-8 h-8 rounded-full"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-green-600 text-white flex items-center justify-center">
                  {user.email?.charAt(0).toUpperCase() || 'U'}
                </div>
              )}
              <span className="text-sm font-medium hidden md:block">
                {user.user_metadata?.full_name || user.email}
              </span>
            </div>
            <button 
              onClick={handleSignOut}
              className="sign-out-button px-3 py-1 text-sm bg-red-50 text-red-600 hover:bg-red-100 rounded-md transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout; 